import React from 'react';
import { portfolioData } from '../data/mock';
import { Cloud, Server, Activity, Code, Settings, Wrench } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';

const SkillsSection = () => {
  const { skills } = portfolioData;

  const skillCategories = [
    {
      title: 'Cloud Platforms',
      icon: Cloud,
      skills: skills.cloud,
      color: 'emerald'
    },
    {
      title: 'Orchestration',
      icon: Server,
      skills: skills.orchestration,
      color: 'cyan'
    },
    {
      title: 'Observability',
      icon: Activity,
      skills: skills.observability,
      color: 'emerald'
    },
    {
      title: 'Infrastructure as Code',
      icon: Code,
      skills: skills.iac,
      color: 'cyan'
    },
    {
      title: 'Automation',
      icon: Settings,
      skills: skills.automation,
      color: 'emerald'
    },
    {
      title: 'Tools & More',
      icon: Wrench,
      skills: skills.tools,
      color: 'cyan'
    }
  ];

  return (
    <section id="skills" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#1a1d29]">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            <span className="text-emerald-400 font-mono text-xl">03.</span> Skills & Technologies
          </h2>
          <div className="h-px bg-gray-700 mt-4"></div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {skillCategories.map((category, index) => {
            const IconComponent = category.icon;
            return (
              <Card
                key={index}
                className="bg-[#0f1419] border-gray-800 hover:border-emerald-500/50 transition-all duration-300 p-6"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-lg bg-emerald-500/10 flex items-center justify-center">
                    <IconComponent size={24} className="text-emerald-400" />
                  </div>
                  <h3 className="text-lg font-semibold text-white">{category.title}</h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {category.skills.map((skill, idx) => (
                    <Badge
                      key={idx}
                      variant="outline"
                      className="border-gray-700 text-gray-300 hover:border-emerald-500 hover:text-emerald-400 transition-colors duration-200 cursor-default"
                    >
                      {skill}
                    </Badge>
                  ))}
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
